import Vue from "vue";

const store = {
  state: {
    instances: [],
    geos: [],
    loadingGeos: false,
    activeInstance: null,
    total: 0,
    model: null,
    nextPage: "",
    prevPage: "",
    loading: true,
    current: 1,
    query: {},
  },
  cleanParams(params) {
    const keysForDel = [];
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        const v = params[key];
        if (v === undefined || v === null || v === "null" || v === "") {
          keysForDel.push(key);
        }
      }
    }
    keysForDel.forEach((k) => {
      delete params[k];
    });
    return params;
  },
  places(name) {
    let toFetch = "/presentes/api/geos/";
    if (name) {
      toFetch += `?search=${name}`;
    }
    this.state.loadingGeos = true;
    const req = Vue.http.get(toFetch);
    req.then((resp) => {
      if (resp.status >= 400 && resp.status < 600) {
        throw resp;
      }
      resp.json().then((json) => {
        this.state.geos = [];
        json.results.forEach((item) => this.state.geos.push(item));
      });
      this.state.loadingGeos = false;
    });
  },
};

export default store;
